module.exports = __webpack_public_path__ + "static/media/cmfoundation.18b0f36a.png";